import { Result } from '@uppy/transloadit';
import { UcsSdk } from '@brandfolder/ucs-sdk-browser';

export interface UppyUploaderProps {
  handleUpload: (files: Result[]) => void;
  uniqIdentifier: string;
  trigger?: `#${string}`; // Required for modal mode, optional for inline mode
  onTriggerClickHandler?: React.MutableRefObject<((event: React.MouseEvent) => void) | null>; // Ref to store the trigger click handler function
  uploadLinkKey?: string; // Required for guest upload flow only
  button?: boolean;
  closeOnComplete?: boolean;
  locale?: {
    strings: {
      dropHereOr: string;
      browse: string;
    }
  };
  endpoint?: string;
  restrictions?: {
    maxNumberOfFiles?: number;
    maxFileSize?: number;
    allowedFileTypes?: string[];
  };
  template?: string;
  ucsSdk?: UcsSdk;
  inline?: boolean; // When true, renders inline dashboard instead of modal
  guestUpload?: boolean; // When true, renders guest upload
};
